import words      from './actions/words'
import votes      from './actions/votes.coffee'
import sentences      from './actions/sentences'
import users           from './actions/users.coffee'
import layouts         from './actions/layouts.coffee'
import filters         from './actions/filters'
import uuids         from './actions/uuids.coffee'

export default {
  ...users,
  ...layouts,
  ...filters,
  ...votes,
  ...words,
  ...sentences,
  ...uuids
}



// WEBPACK FOOTER //
// ./src/store/actions.js